import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { copyToClipboard } from "@toothfairy/shared-ui/ClipboardUtils";
import AppToast from "@toothfairy/shared-ui/AppToast";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

const IdCopyView = ({ id, label, wrapperStyle }) => {
  const { t } = useTranslation();
  const AppToasty = AppToast.useToast();

  const handleCopyId = async () => {
    try {
      const success = await copyToClipboard(id);
      if (success) {
        AppToasty.show(t("toasts.copied"), { type: "success" });
      } else {
        AppToasty.show(t("toasts.copyFailed"), { type: "danger" });
      }
    } catch (error) {
      console.error("Copy failed:", error);
      AppToasty.show(t("toasts.copyFailed"), { type: "danger" });
    }
  };

  return (
    <View
      style={[
        {
          flexDirection: "row",
          alignItems: "center",
          marginLeft: 10,
          marginTop: 10,
        },
        wrapperStyle,
      ]}
    >
      <AppText style={{ fontWeight: "bold", fontSize: 12 }}>
        {label || t("settings.list.id")}: {id}
      </AppText>
      <AppIcon
        icon={AppAssets.icons.copy}
        isClickable
        size={14}
        onPress={handleCopyId}
        wrapperStyle={{ marginLeft: 6 }}
      />
    </View>
  );
};

export default IdCopyView;
